export default __webpack_public_path__ + "static/scenes4-8b249f635fd135f449ea526930d984ce.jpg";